module.exports = __webpack_public_path__ + "img/welding-2.30ff3e3e.jpg";